import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Check AWS SES Email")
], -1)
const _hoisted_3 = { class: "card-body fs-5" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-4"
}

import SystemService from "@/projects/tenant/modules/system/services/SystemService";
import { ref, onMounted } from "vue";
import { TenantTypes } from "@/core/types/TenantTypes";
import { getCurrentInstance } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'EmailCheck',
  setup(__props) {

const isLoading = ref(false);
const data = ref<any>([]);
const totalUsers = ref(0);
const tenantId = ref<any>(null);
const emailAddress = ref("");
const checkResult = ref<any>(null);
const error = ref<any>(null);

var siteColors = {
  au: "#7a9e7a",
  bvi: "#fa6b6c",
  sea: "#349beb",
  mn: "#b497b4",
  jp: "#f6c23e",
};

const getSiteColor = (site: any) => {
  return siteColors[TenantTypes[site]] || "#000000"; // default color if site not found
};

const removeEmailAddress = async (email) => {
  isLoading.value = true;
  try {
    const response = await SystemService.removeEmailSuppression(email);
    error.value = "Removed successfully";
  } catch (e) {
    error.value = "Removed failed: " + e;
  }
  isLoading.value = false;
};

const checkEmailAddress = async () => {
  if (!emailAddress.value) {
    return false;
  }
  checkResult.value = null;
  isLoading.value = true;
  error.value = null;
  try {
    const response = await SystemService.checkEmailSuppression(
      emailAddress.value
    );
    checkResult.value = {
      email: emailAddress.value,
      status: response,
    };
    emailAddress.value = "";
  } catch (e) {
    error.value = "Error: " + e;
  }
  isLoading.value = false;
};

onMounted(() => {
  tenantId.value = localStorage.getItem("tenant");
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_input, {
          modelValue: emailAddress.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailAddress).value = $event)),
          style: {"max-width":"600px"},
          placeholder: "Please input",
          class: "input-with-select"
        }, {
          prepend: _withCtx(() => [
            _createTextVNode("Email")
          ]),
          append: _withCtx(() => [
            _createVNode(_component_el_button, {
              textContent: 'Search',
              onClick: checkEmailAddress,
              disabled: isLoading.value
            }, null, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      (checkResult.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(checkResult.value.email) + ": " + _toDisplayString(checkResult.value.status) + " ", 1),
            (checkResult.value.status)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "danger",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (removeEmailAddress(checkResult.value.email))),
                  loading: isLoading.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Remove")
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})